import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';

function useCounter(initialValue) {
  var _useState = useState(initialValue || 0),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var increment = function increment() {
    return setCount(function (x) {
      return x + 1;
    });
  };

  var decrement = function decrement() {
    return setCount(function (x) {
      return x - 1;
    });
  };

  var reset = function reset() {
    return setCount(initialValue || 0);
  };

  return {
    count: count,
    increment: increment,
    decrement: decrement,
    reset: reset,
    setCount: setCount
  };
}

export default useCounter;